import { N05 } from "./N05";
import { N11 } from "./N11";
import { N12 } from "./N12";
import { N13 } from "./N13";
import { N14 } from "./N14";
import { N15 } from "./N15";
import { N16 } from "./N16";

export const CoverageOverviewReport = {
  sections: [ 
    N12,
    N11,
    N13,
    N14,
    N15,
    N16,
    N05
  ],
};
